import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Lang from '@lang/en';
import Label from '../../common/Label';
import DateFilter from './exactDateFilter';
import { onDateChangeType } from './types';
import { DateGroup } from './styles';

interface Props {
  onStartDateChange: onDateChangeType;
  onEndDateChange: onDateChangeType;
  minDate?: string | null;
  startDate: string | null;
  endDate: string | null;
  newDesign?: boolean;
  inputWidth?: number;
}

const DateRangeFilter: React.FC<Props> = ({
  onStartDateChange,
  onEndDateChange,
  minDate,
  startDate,
  endDate,
  newDesign,
  inputWidth,
}) => {
  return (
    <>
      <DateGroup>
        <Label>{Lang.dateFrom}</Label>
        <DateFilter
          onDateChange={(value) => onStartDateChange(value)}
          value={startDate}
          minDate={minDate}
          data-testid="common-dateRangeFilter-dateFrom"
          inputWidth={inputWidth}
        />
      </DateGroup>
      <DateGroup>
        <Label>{Lang.dateTo}</Label>
        <DateFilter
          onDateChange={(value) => onEndDateChange(value)}
          value={endDate}
          selectsEnd
          minDate={startDate}
          disabled={!newDesign && !startDate}
          data-testid="common-dateRangeFilter-dateTo"
          inputWidth={inputWidth}
        />
      </DateGroup>
    </>
  );
};

export default DateRangeFilter;
